module.exports = {
  langs: ['en', 'is'],
  defaultLangKey: 'en'
};



// WEBPACK FOOTER //
// ./src/data/languages.js